import type { ReactElement } from 'react';
import { Button } from '../../ui/Button';
import { Icon } from '../../ui/Icon';
import type { MicrophoneHelp } from './micAccess';
import s from './Voice.module.css';

/**
 * What stopped the microphone and the fix for this browser, with Try again (APP-104 §3.2). Ported
 * from Menos's MicHelp.jsx; there's no "Open System Settings" here, which only its desktop app
 * could do. Once the person has words in the box, or the browser has allowed the microphone, the
 * button is Record: it adds what they say to their words.
 */
export function MicHelp({
  help,
  retryLabel,
  onRetry,
}: {
  help: MicrophoneHelp;
  retryLabel: 'Try again' | 'Record';
  /** Null while the review is sending. */
  onRetry: (() => void) | null;
}): ReactElement {
  return (
    <div className={s.micHelp} role="alert">
      <Icon name="micOff" size={20} className={s.micIcon} />
      <div>
        <p className={s.micTitle}>{help.title}</p>
        <p className={s.micStep}>{help.step}</p>
      </div>
      {onRetry !== null && (
        <div className={s.micActions}>
          <Button
            variant="ghost"
            size="sm"
            onPress={onRetry}
            icon={<Icon name={retryLabel === 'Record' ? 'mic' : 'refresh'} size={16} />}
          >
            {retryLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
